import React from 'react';
import './convs.css';

const PdfViewer = () => {
  const isMobile = window.innerWidth <= 768; 

  return (
    <div align='center' className="pdf-viewer-container">
      <h2 className="pdf-viewer-title">Programa Anual de Desarrollo Archivístico 2023</h2>
      {isMobile ? (
       
        <div className="pdf-viewer-mobile">
          <a
            href={`http://transparenciadocs.hidalgo.gob.mx/dependencias/sedeso/2023/48Rub-1er-t/45DGA/PADA_2023.pdf`}
            download
            className="pdf-viewer-download"
          >
            Descargar PDF
          </a>
        </div>
      ) : (
        // Si no es un dispositivo móvil, mostrar el visor de PDF en un iframe
        <div className="pdf-viewer-wrapper">
          <iframe
            src={`http://transparenciadocs.hidalgo.gob.mx/dependencias/sedeso/2023/48Rub-1er-t/45DGA/PADA_2023.pdf`}
            title="Visor de PDF"
            className="pdf-viewer-iframe"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;